import classNames from 'classnames';
import { BatchNavigationContext } from 'components/common-form/contexts/batch/BatchNavigationContext';
import { FC, useContext } from 'react';

export const NonRelevantCell: FC = () => {
  const { isSelected } = useContext(BatchNavigationContext);

  return <div className={classNames('h-100', isSelected ? '' : 'bg-lvl2')} />;
};

NonRelevantCell.displayName = 'NonRelevantCell';
